'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ownerState", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useMessageContext } from "./internals/MessageContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const MessageAvatar = /*#__PURE__*/React.forwardRef(function MessageAvatar(props, ref) {
  const _ref = props,
    {
      ownerState: ownerStateProp,
      slots,
      slotProps
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ownerState = useMessageContext();
  const avatarUrl = ownerState.resolvedAuthor?.avatarUrl;
  const displayName = ownerState.resolvedAuthor?.displayName;
  void ownerStateProp;
  const Avatar = slots?.avatar ?? 'div';
  const avatarProps = useSlotProps({
    elementType: Avatar,
    externalSlotProps: slotProps?.avatar,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  const Image = slots?.image ?? 'img';
  const imageProps = useSlotProps({
    elementType: Image,
    externalSlotProps: slotProps?.image,
    ownerState,
    additionalProps: {
      alt: displayName ?? '',
      src: avatarUrl ?? undefined
    }
  });
  if (ownerState.role === 'system' || ownerState.message == null) {
    return null;
  }
  if (ownerState.isGrouped) {
    return null;
  }
  if (avatarUrl == null && slots?.avatar == null) {
    return null;
  }
  return /*#__PURE__*/_jsx(Avatar, _extends({}, avatarProps, {
    children: avatarUrl ? /*#__PURE__*/_jsx(Image, _extends({}, imageProps)) : null
  }));
});
if (process.env.NODE_ENV !== "production") MessageAvatar.displayName = "MessageAvatar";